// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"22":"eb209157","161":"08161c46"}[chunkId] + ".css";
};